import { render } from "./TabHealth.vue?vue&type=template&id=05a972c4&ts=true"
import script from "./TabHealth.vue?vue&type=script&lang=ts"
export * from "./TabHealth.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__